import{jsxs as m,jsx as c}from"react/jsx-runtime";import i,{css as a}from"styled-components";import e from"../../theme.js";import{BodyText as x}from"../../typography/BodyText/index.js";import{BackgroundStyles as f}from"../IconButton.js";import{useNameAndId as k}from"../../hooks/useNameAndId.js";import"../../shared/media-queries.js";import"../../utils/utils.js";import"react";import"../../shared/helpers.js";const y=a`
  .circle {
    &--outer {
      height: 24px;
      width: 24px;
    }

    &--inner {
      height: 100%;
      width: 100%;
      transform: scale(0.6);
    }
  }
`,D=a`
  .circle {
    &--outer {
      height: 32px;
      width: 32px;
    }

    &--inner {
      height: 100%;
      width: 100%;
      transform: scale(0.6);
    }
  }
`,u={regular:y,large:D},z=a`
  cursor: default;

  .circle {
    &--inner {
      background-color: ${e.colors.grayscaleToned.light2};
    }

    &--outer {
      border: 2px solid ${e.colors.grayscaleToned.light2};
    }
  }
`,v=a`
  .circle {
    &--inner {
      opacity: 1;
      background-color: ${e.colors.grayscaleToned.light2};
    }
  }
`,S=(r,o,s)=>a`
  .circle {
    &--inner {
      opacity: 1;
      background-color: ${e.colors[r][o]};
    }

    &--outer {
      border: 2px solid
        ${s?e.colors.error.dark:e.colors[r][o]};
    }
  }
`,E=i.div`
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
`,N=i.span`
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  ${r=>u[r.size]};

  ${r=>!r.isDisabled&&r.isChecked&&S(r.$color,r.$colorShade,r.$hasError)};
  ${r=>r.isDisabled&&z};

  ${r=>r.isChecked&&r.isDisabled&&v};

  &:hover,
  &:focus {
    border-radius: 50%;
    transition: background-color 400ms;
    ${f}
  }
`,T=i.input`
  position: absolute;
  opacity: 0;
  margin: 0;
  ${r=>!r.isDisabled&&"cursor: pointer;"}
  z-index: 1;
  ${r=>u[r.$size]};
`,w=i.span`
  display: flex;
  box-sizing: border-box;
  border-radius: 50%;

  border: 2px solid
    ${r=>r.$hasError?e.colors.error.dark:e.colors.grayscaleToned.dark5};
`,B=i.span`
  box-sizing: border-box;
  opacity: 0;
  margin: auto;
  border-radius: 50%;

  position: absolute;
  top: 0;
  left: 0;
`,C=i(x)`
  cursor: ${({isDisabled:r})=>r?"default":"pointer"};
  user-select: none;
  color: ${({theme:r,isDisabled:o})=>o?r.colors.text.disabled:r.colors.text.dark};
  margin-left: 0.5rem;
`,g=({name:r,size:o="regular",checked:s=!1,isDisabled:l=!1,color:n="secondary",colorShade:h="mainAlt",label:t,hasError:d,...$})=>{const{name:b,id:p}=k("radio-button",r);return m(E,{children:[m(N,{size:o,$color:n,$colorShade:h,isChecked:s,isDisabled:l,$hasError:d,children:[c(T,{"data-validate":"checked",checked:s,type:"radio",name:b,id:p,disabled:l,"aria-label":t?void 0:b,"aria-checked":s,"aria-invalid":d||void 0,className:"circle circle--outer",$size:o,isDisabled:l,$color:n,$colorShade:h,...$}),c(w,{className:"circle circle--outer",$hasError:d,children:c(B,{className:"circle circle--inner"})})]}),t&&c(C,{as:"label",htmlFor:p,isDisabled:l,children:t})]})};export{g as RadioButton,g as default};
